import { useLayoutEffect, type RefObject } from "react";

const DEFAULT_MIN = 44;
const DEFAULT_MAX = 220;

/**
 * Ajuste la hauteur d’un textarea à son contenu (entre min et max en px).
 * Au-delà de max, le textarea devient scrollable.
 */
export const useAutosizeTextarea = (
  textareaRef: RefObject<HTMLTextAreaElement | null>,
  value: string,
  options?: { minHeightPx?: number; maxHeightPx?: number },
) => {
  const minH = options?.minHeightPx ?? DEFAULT_MIN;
  const maxH = options?.maxHeightPx ?? DEFAULT_MAX;

  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "0px";
    const scroll = el.scrollHeight;
    const next = Math.min(Math.max(scroll, minH), maxH);
    el.style.height = `${next}px`;
    el.style.overflowY = scroll > maxH ? "auto" : "hidden";
  }, [value, minH, maxH]);
};
